export function Footer() {
  // Jahr aus der Laufzeit, nie hartkodiert.
  const jahr = new Date().getFullYear()

  return (
    <footer className="text-on-surface-muted mt-auto pt-16 pb-8 text-center text-sm">
      © {jahr} Martin Pfeffer |{' '}
      <a
        href="https://celox.io"
        className="hover:text-on-surface underline decoration-transparent underline-offset-4 transition-colors hover:decoration-current"
      >
        celox.io
      </a>
    </footer>
  )
}
